import { render, staticRenderFns } from "./ProductDenoList.vue?vue&type=template&id=3273bfea&scoped=true"
import script from "./ProductDenoList.vue?vue&type=script&lang=js"
export * from "./ProductDenoList.vue?vue&type=script&lang=js"
import style0 from "./ProductDenoList.vue?vue&type=style&index=0&id=3273bfea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3273bfea",
  null
  
)

export default component.exports